import { render, staticRenderFns } from "./MmfTable.vue?vue&type=template&id=5e858198&"
import script from "./MmfTable.vue?vue&type=script&lang=js&"
export * from "./MmfTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports